import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UserNameDto } from 'remarketing-angular-library';
import { Subject } from 'rxjs';


@Component({
    selector: 'user-popover',
    templateUrl: './user-popover.component.html',
    styleUrls: ['./user-popover.component.scss'],
    imports: []
})
export class UserPopoverComponent implements OnDestroy {

  @Input() userValues: Array<UserNameDto> = [];

  @Output() closePop = new EventEmitter();

  @Output() userSelected = new EventEmitter<UserNameDto>();

  private destroyed$ = new Subject();

  constructor() {}

  selectUser(userValue: UserNameDto) {
    this.userSelected.emit(userValue);
    this.close();
  }

  close() {
    this.closePop.emit();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
